import request from '@/utils/request';
/**
 *
 * 分类管理
 *
 **/

// 查询分类列表接口（按店铺）
export const getCategoryPage = (params: any) => {
  return request({
    url: '/category/page/store',
    method: 'get',
    params
  });
};

// 分类下拉：onlyRoot=true 一级；parentId=xx 直接子级；leafOnly=true 仅叶子（三级时一般为品牌，挂商品/套餐用）
export const getCategoryList = (params: any) => {
  return request({
    url: '/category/list',
    method: 'get',
    params
  });
};

// 删除当前列的接口
export const deleCategory = (ids: string) => {
  return request({
    url: '/category',
    method: 'delete',
    params: { id:ids }
  });
};

// 修改接口
export const editCategory = (params: any) => {
  return request({
    url: '/category',
    method: 'put',
    data: { ...params }
  });
};

// 新增接口
export const addCategory = (params: any) => {
  return request({
    url: '/category',
    method: 'post',
    data: { ...params }
  });
};

// 修改---启用禁用接口
export const enableOrDisableEmployee = (params: any) => {
  return request({
    url: `/category/status/${params.status}`,
    method: 'post',
    params: { id:params.id }
  })
}

/** 分类同级排序上下移 */
export const categoryMoveSort = (params: { id: number | string; direction: 'up' | 'down' }) => {
  return request({
    url: `/category/sort/${params.direction}`,
    method: 'post',
    params: { id: params.id }
  })
}

/** 直接设置分类排序值（越小越靠前） */
export const categorySetSort = (params: { id: number | string; sort: number }) => {
  return request({
    url: `/category/sort`,
    method: 'post',
    params: { id: params.id, sort: params.sort }
  })
}
